<app-exam-recommendation-popup
  [isOpen]="true"
  (close)="closeRecommendationPopup()"
  (enterFullScreen)="enterFullScreen()"></app-exam-recommendation-popup>
